export const dateFormat: string = 'MM-dd-yyyy';
export const timeFormat: string = 'MM-dd-yyyy hh:mm:ss a';
export const priceFormat: string = '1.2-2';
export const dateFormatWithDay: string = 'EEEE MM/dd/yy';
export const onlyTimeFormat: string = 'h:mm a';
